import { environment } from './../../environments/environment';
import { UtilsService } from './utils.service';
import * as i0 from "@angular/core";
import * as i1 from "./utils.service";
var MyteamsService = /** @class */ (function () {
    function MyteamsService(_utilsService) {
        this._utilsService = _utilsService;
    }
    MyteamsService.prototype.getContestListing = function (user_id, type, lgIndex, tIndex, live, game_id, playersBool, search, season) {
        if (search === void 0) { search = null; }
        if (season === void 0) { season = null; }
        var url = environment.boxScoreUrl + "/contestListing2/" + user_id + "/" + type + "/" + lgIndex + "/" + tIndex + "/" + live + "/" + game_id + "/" + ((playersBool) ? '1' : '0') + ((search == null) ? '' : '/' + search);
        if (live == 'history') {
            url = environment.boxScoreUrl + "/api/front/historyContestListing?type=" + type + "&lgIndex=" + lgIndex + "&tIndex=" + tIndex + "&live=" + live + "&game_id=" + game_id + "&players=" + (playersBool ? '1' : '0') + (search ? "&search=" + search : '') + "&season=" + season;
        }
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.getContestPlayers = function (slug, auto, entryId, seasonId) {
        if (auto === void 0) { auto = 0; }
        if (entryId === void 0) { entryId = 0; }
        if (seasonId === void 0) { seasonId = 0; }
        var query = (auto) ? '?auto=1&entryId=' + entryId + '' : '?a=1';
        if (seasonId)
            query = query + '&season=' + seasonId;
        var url = environment.boxScoreUrl + "/getMyTeam/" + slug + query;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.getSwapPlayerData = function (league_id, user_id, session_id) {
        var url = environment.boxScoreUrl + "/getPlayersData/" + league_id + "/" + user_id + "/" + session_id;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.getSwappedPlayers = function (league_id, swap_uuid, session_id) {
        var url = environment.phpApiUrl + "/swapPlayers/getSwappedPlayers/" + environment.DRAFT_ACCESS_TOKEN + "/" + league_id + "/" + swap_uuid + "/" + session_id;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.updateSwapPlayer = function (post_data) {
        var url = environment.phpApiUrl + "/player/updateLeaguePlayers/";
        return this._utilsService.putRequest(url, post_data, null, 'content-type-json');
    };
    MyteamsService.prototype.updateMultiSwapPlayer = function (post_data) {
        var url = environment.phpApiUrl + "/fantasyLeague/updateMultiSwapLeaguePlayers/";
        return this._utilsService.postRequest(url, post_data, null, 'content-type-json');
    };
    MyteamsService.prototype.getContestPlayersWeek = function (slug, week, seasonId) {
        if (seasonId === void 0) { seasonId = 0; }
        var url = environment.boxScoreUrl + "/getMyTeam/" + slug + "/-1/0/0/" + week;
        if (seasonId)
            url = url + '?season=' + seasonId;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.getContestPlayersMove = function (slug, player_id) {
        var url = environment.boxScoreUrl + "/getMyTeam/" + slug + "/-1/" + player_id;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.expandTour = function (lgm_ids, search, seasonId) {
        if (seasonId === void 0) { seasonId = 0; }
        var url = environment.boxScoreUrl + "/tourListing";
        if (seasonId)
            url = url + '?season=' + seasonId;
        return this._utilsService.postRequest(url, { lgm_ids: lgm_ids, search: search }, null, 'content-type-json');
    };
    MyteamsService.prototype.liveRefresh = function (lgms, tours, user_id) {
        return this._utilsService.postRequest(environment.boxScoreUrl + "/liveRefresh", { lgms: lgms, tours: tours, user_id: user_id }, null, 'content-type-json');
    };
    MyteamsService.prototype.addPlayerToSwap = function (post_data) {
        return this._utilsService.postRequest(environment.phpApiUrl + "/swapPlayers/addToSwapQueue", post_data, null, 'content-type-json');
    };
    MyteamsService.prototype.getMultiSwapLeagues = function (post_data) {
        return this._utilsService.postRequest(environment.phpApiUrl + "/fantasyLeague/getMultiSwapLeaguePlayers", post_data, null, 'content-type-json');
    };
    MyteamsService.prototype.getOtherLeaguesForMultiSwap = function (post_data) {
        return this._utilsService.postRequest(environment.phpApiUrl + "/fantasyLeague/getOtherLeaguesForMultiSwap", post_data, null, 'content-type-json');
    };
    MyteamsService.prototype.liveStandings = function (id, type, offset, limit, duration_id, game_id) {
        var url = environment.boxScoreUrl + "/liveStandings/" + id + "/" + type + "/" + offset + "/" + limit + "/" + duration_id + "/" + game_id;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.getStandings = function (id, type, offset, limit, seasonId) {
        if (seasonId === void 0) { seasonId = 0; }
        var url = environment.boxScoreUrl + "/contestStandings/" + id + "/" + type + "/" + offset + "/" + limit;
        if (seasonId)
            url = url + "?season=" + seasonId;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.getMyStandings = function (id, type, user_id, seasonId) {
        if (seasonId === void 0) { seasonId = 0; }
        var url = environment.boxScoreUrl + "/myStandings/" + user_id + "/" + id + "/" + type;
        if (seasonId)
            url = url + "?season=" + seasonId;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.movePlayers = function (lgm_id, fl_id, player_in, player_out, user_id) {
        var url = environment.phpApiUrl + "/swap/moveSwap/" + environment.DRAFT_ACCESS_TOKEN + "/" + lgm_id + "/" + fl_id + "/" + player_in + "/" + player_out + "/" + user_id;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.getWeekMatrix = function (lgm_id, game_id) {
        var url = environment.boxScoreUrl + "/bestball/weekMatrix/" + lgm_id + "?game_id=" + game_id;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.trackMismatch = function (lgm_id) {
        var url = environment.phpApiUrl + "/league/trackLogs/" + environment.DRAFT_ACCESS_TOKEN + "/" + lgm_id;
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.getContestInfo = function (lg_id) {
        var url = environment.boxScoreUrl + "/getLeagueData/" + lg_id + "/0";
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.prototype.getSeasonList = function () {
        var url = environment.boxScoreUrl + "/api/front/getSeasonList";
        return this._utilsService.getRequest(url, null, 'content-type-json');
    };
    MyteamsService.ngInjectableDef = i0.defineInjectable({ factory: function MyteamsService_Factory() { return new MyteamsService(i0.inject(i1.UtilsService)); }, token: MyteamsService, providedIn: "root" });
    return MyteamsService;
}());
export { MyteamsService };
